export enum UserRoleEnum {
    USER = 'user',
    ADMIN = 'admin',
    UNKNOWN = 'unknown',
}
